import logo from "@/assets/logo.webp";

/** Intrinsic pixel size of `logo.webp` — keep HTML and CSS ratio in lockstep. */
export const LOGO_WIDTH = 80;
export const LOGO_HEIGHT = 93;

const sizes = {
  header: { heightClass: "h-10", heightRem: 2.5 },
  footer: { heightClass: "h-9", heightRem: 2.25 },
} as const;

export function BrandLogo({ size }: { size: keyof typeof sizes }) {
  const { heightClass, heightRem } = sizes[size];
  return (
    <img
      src={logo}
      alt=""
      width={LOGO_WIDTH}
      height={LOGO_HEIGHT}
      decoding="async"
      fetchPriority="low"
      className={`${heightClass} max-w-none shrink-0 object-contain`}
      style={{
        width: `calc(${heightRem}rem * ${LOGO_WIDTH} / ${LOGO_HEIGHT})`,
        aspectRatio: `${LOGO_WIDTH} / ${LOGO_HEIGHT}`,
      }}
    />
  );
}
